import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { i18n } from './i18n';
import { LanguageProvider, useLanguage } from './LanguageContext';
import { LocaleProvider } from './LocaleContext';
import { DEFAULT_LANGUAGE, DEFAULT_LOCALE, isSupportedLanguage, isSupportedLocale, } from './types';
function resolveLanguage(language) {
    if (language !== null && language !== undefined && isSupportedLanguage(language))
        return language;
    return DEFAULT_LANGUAGE;
}
function resolveLocale(locale) {
    if (locale !== null && locale !== undefined && isSupportedLocale(locale))
        return locale;
    return DEFAULT_LOCALE;
}
function LanguageSyncer({ resolvedLanguage }) {
    const { setLanguage } = useLanguage();
    useEffect(() => {
        if (i18n.language !== resolvedLanguage) {
            void i18n.changeLanguage(resolvedLanguage);
        }
        setLanguage(resolvedLanguage);
    }, [resolvedLanguage, setLanguage]);
    return null;
}
export function I18nProvider({ language, locale, children }) {
    const resolvedLanguage = resolveLanguage(language);
    const resolvedLocale = resolveLocale(locale);
    return (_jsx(I18nextProvider, { i18n: i18n, children: _jsxs(LanguageProvider, { initialLanguage: resolvedLanguage, children: [_jsx(LanguageSyncer, { resolvedLanguage: resolvedLanguage }), _jsx(LocaleProvider, { initialLocale: resolvedLocale, children: children })] }) }));
}
export { i18n };
